export default __webpack_public_path__ + "static/media/Primer_Mix_of_Primers_3_and_4.73504e9f.svg";